import { AdminAction } from './adminaction.model';
import { BreadCrumb } from './breadcrumb.model';
import { HeaderButton } from './headerbtn.model';

export class ComponentHeader {
    maintitle : string;
    //subtitle    :   string;
    breadcrumbs : BreadCrumb[] = [];
    adminactions: AdminAction[] = []
    touroptions: any[] = []
  loadingprogress: number = 0;
    //buttons :   HeaderButton[];

}

